import React from "react";
import PropTypes from "prop-types";
import { Icon } from "semantic-ui-react";
import { detect } from "detect-browser";
import { CollectionResponse } from "active-resource";
import Loading from "../../shared/loaders/Loading";
import Notification from "../../shared/notifications/Notification";
import {
  NotificationsWrapper,
  Header,
  MarkAsRead,
  ItemsWrapper,
  Item,
  Footer,
  NotificationsLink,
  AboutNotification,
  NotificationLink,
  IconWrapper,
  NotificationIcon,
  BodyWrapper,
  NotificationText,
  Subject,
  Time,
} from "./styles/notifications-data-styles";

export const NotificationItems = (props) => {
  const iOS = detect().name === "ios";

  const {
    dropdownVisible,
    loading,
    markAllNotificationsReadUrl,
    notifications,
    notificationsUrl,
  } = props;

  let itemsForWrapper;

  if (loading) {
    itemsForWrapper = <Loading />;
  } else {
    itemsForWrapper = notifications.empty() ? (
      <Item>
        <NotificationText data-test-id="no-notifications">
          You have no new notifications
        </NotificationText>
      </Item>
    ) : (
      notifications.toArray().map((notification) => (
        <Item
          key={notification.id}
          data-test-id={`notification-${notification.id}`}
        >
          <Notification
            notification={notification}
            key={notification.id}
            AboutNotification={AboutNotification}
            NotificationLink={NotificationLink}
            IconWrapper={IconWrapper}
            NotificationIcon={NotificationIcon}
            BodyWrapper={BodyWrapper}
            NotificationText={NotificationText}
            Subject={Subject}
            Time={Time}
          />
        </Item>
      ))
    );
  }

  return (
    <NotificationsWrapper
      className={`${dropdownVisible ? "active" : null}`}
      iOS={iOS}
    >
      <Header>
        Notifications
        <MarkAsRead
          href={markAllNotificationsReadUrl}
          data-remote="true"
          title="Mark all as Read"
          rel="nofollow"
          data-method="post"
        >
          Mark all as Read
        </MarkAsRead>
      </Header>
      <ItemsWrapper>{itemsForWrapper}</ItemsWrapper>
      <Footer iOS={iOS}>
        <NotificationsLink href={notificationsUrl} title="All Notifications">
          <Icon name="bell" />
          All Notifications
        </NotificationsLink>
      </Footer>
    </NotificationsWrapper>
  );
};

NotificationItems.propTypes = {
  dropdownVisible: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  markAllNotificationsReadUrl: PropTypes.string.isRequired,
  notifications: PropTypes.instanceOf(CollectionResponse).isRequired,
  notificationsUrl: PropTypes.string.isRequired,
};

export default NotificationItems;
